import React from "react";
import { useSelector } from "react-redux";
import { getForecastValue, getGoalValue } from "../goalsModule";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import DonutForecast from "./DonutForecast";

const TopGoals = () => {
  const topGoals = useSelector((state) => state.goals.topGoals);

  const bottomGoals = useSelector((state) => state.goals.bottomGoals);
  const isCurrentMonth = useSelector((state) => state.goals.isCurrentMonth);
  const singleLocation = useSelector((state) => state.goals.currentUser.singleLocation);
  const moduleView = useSelector((state) => state.goals.selectedModuleView);
  const topGoalsLoading = useSelector((state) => state.goals?.topGoalsLoading);

  const formatGoalsData = (type) => {
    let dataArray = type === "top" ? topGoals : bottomGoals;

    return dataArray.map((item) => ({
      metricTitle: item.title,
      metricLocation: item.locationName,
      entityName: item.entityName,
      hidePercentChanged: true,
      showForecast: true,
      currentValPacing: item.currentValPacing,
      forecastValue: getForecastValue(item),
      value: getGoalValue(item),
      goalCurrentVal: item.currentVal,
      goalRemainValue:
        item.prevPeriodVal * (item.goalIncrease / 100) + item.prevPeriodVal - item.currentVal,
      currencySymbol: item.currencySymbol,
      goalUsesPercent: item.goalUsesPercent,
      goalValue: item.goalValue
    }));
  };

  let cleanedDataTop = formatGoalsData("top");
  let cleanedDataBottom = formatGoalsData("bottom");

  return (
    <div
      className="section-content-inner"
      style={{
        paddingTop: "40px",
        height: "300px",
        position: "relative",
        width: "1350px",
        margin: "0 auto"
      }}
    >
      {topGoalsLoading ? (
        <LoadingAnimation customStyle="top-goals-loader" />
      ) : topGoals.length || bottomGoals.length ? (
        <div className="goals-summary-wrapper">
          <div
            className="goals-donuts"
            style={{
              width: "50%",
              borderRight: "solid 1px #50555f",
              marginRight: "16px"
            }}
          >
            <h5 className="title most">Closest To Completion</h5>
            {cleanedDataTop.map((item, key) => {
              return (
                <DonutForecast
                  title=""
                  metricTitle={item.metricTitle}
                  metricLocation={item.metricLocation}
                  entityName={item.entityName}
                  hidePercentChanged
                  showForecast
                  currentValPacing={item.currentValPacing}
                  forecastValue={item.forecastValue}
                  value={item.value}
                  goalCurrentVal={item.goalCurrentVal}
                  goalUsesPercent={item.goalUsesPercent}
                  goalValue={item.goalValue}
                  goalRemainValue={item.goalRemainValue}
                  isStaffView={moduleView.id === "staff"}
                  currencySymbol={item.currencySymbol}
                  singleLocation={singleLocation}
                  key={`DonutForecast${key}`}
                  hideForecast={!isCurrentMonth}
                  width="25%"
                />
              );
            })}
          </div>
          {bottomGoals.length > 0 ? (
            <div
              className="goals-donuts"
              style={{
                width: "50%"
              }}
            >
              <h5 className="title least">Least Likely To Succeed</h5>
              {cleanedDataBottom.map((item, key) => (
                <DonutForecast
                  title=""
                  metricTitle={item.metricTitle}
                  metricLocation={item.metricLocation}
                  entityName={item.entityName}
                  hidePercentChanged
                  showForecast
                  currentValPacing={item.currentValPacing}
                  forecastValue={item.forecastValue}
                  value={item.value}
                  goalCurrentVal={item.goalCurrentVal}
                  goalUsesPercent={item.goalUsesPercent}
                  goalValue={item.goalValue}
                  changeValue={0.03}
                  goalRemainValue={item.goalRemainValue}
                  currencySymbol={item.currencySymbol}
                  isStaffView={moduleView.id === "staff"}
                  singleLocation={singleLocation}
                  hideForecast={!isCurrentMonth}
                  key={`DonutForecast${key}`}
                  width="25%"
                />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default TopGoals;
